const updates = [
  { time: '07-30 14:22', text: '在线吃瓜线路一入口已恢复访问，速度测试正常', tag: '线路恢复', accent: true },
  { time: '07-30 10:15', text: '91在线吃瓜网官方域名解析完成，新增备用通道', tag: '域名更新' },
  { time: '07-29 22:08', text: '在线吃瓜最新入口地址变更通知，请及时更新收藏', tag: '入口变更', accent: true },
  { time: '07-29 16:40', text: '部分区域运营商DNS污染预警，建议切换备用网址', tag: '安全提醒' },
  { time: '07-28 19:55', text: '在线吃瓜备用网址线路三完成扩容，承载能力提升', tag: '线路优化' },
  { time: '07-28 08:30', text: '在线吃瓜网站移动端适配优化完成，手机访问更流畅', tag: '功能更新' },
  { time: '07-27 21:12', text: '紧急修复部分用户访问在线吃瓜入口时出现的白屏问题', tag: '问题修复', accent: true },
  { time: '07-27 11:45', text: '在线吃瓜官方线路全面通过安全检测认证', tag: '安全认证' },
  { time: '07-26 17:03', text: '新增日韩地区CDN加速节点，海外用户访问速度提升40%', tag: '线路扩展' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-8 h-8 rounded-lg bg-primary-500/15 flex items-center justify-center flex-shrink-0">
            <i className="ri-flashlight-line text-primary-400"></i>
          </span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">最新快讯</h2>
        </div>
        <div className="relative pl-6 border-l-2 border-background-300/50">
          {updates.map((item, i) => (
            <div key={i} className="relative pb-8 last:pb-0">
              <span className="absolute -left-[29px] top-1 w-3 h-3 rounded-full bg-background-200 border-2 border-background-300"></span>
              <span className="text-xs text-foreground-600 font-medium mb-1 block">{item.time}</span>
              <p className="text-sm md:text-base text-foreground-300 leading-relaxed">
                {item.text}
                <span className={`ml-2 inline-block px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${
                  item.accent
                    ? 'bg-accent-500/15 text-accent-400'
                    : 'bg-secondary-500/15 text-secondary-400'
                }`}>
                  {item.tag}
                </span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}